import { createSelector } from 'reselect'
import { get } from 'lodash'


const assessors = (assessor, hideAddNew, props) => ({ list: get(assessor, 'assessors.list'), hideAddNew, props })

const mapForDropdown = data => {
  const intl = get(data, 'props.intl')

  const list = get(data, 'list').map(item => ({
    value: item.id,
    label: get(item, 'person.name')
  }))

  const noneOfThese = {
    value: 0,
    label: intl.formatMessage({
      id: 'label.add_my_assessor',
      defaultMessage: 'Add my Assessor'
    })
  }
  const needHelp = {
    value: -1,
    label: intl.formatMessage({
      id: 'label.i_need_help_from_award_leader',
      defaultMessage: 'I need help from Award Leader'
    })
  }

  if (!get(data, 'hideAddNew')) {
    list.unshift(noneOfThese)
  }

  list.push(needHelp)

  return list
}

export default createSelector(assessors, mapForDropdown)
